"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversations.favorite.add': 'Add to favorites',
    'conversations.favorite.remove': 'Remove from favorites',
};
